import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { useDialogContext } from '../Context/DialogContext';
import SucccessImage from '../../assets/done.gif'
import { Stack } from '@mui/material';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => '#292727',
            border:'1px solid #98A2B3',
            borderRadius: '15%',
            width:'56px',
            height:'56px',
            margin:'24px'
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CITDialog() {
  
    const { isOpen, message, onClose } = useDialogContext();
    

  return (
    <div>
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        sx={{ '& .MuiPaper-root':{ width:{xs:'315px', sm:'1200px'}, height: {xs:'440px',sm:'784px'}}, '& .MuiDialog-paper':{maxWidth:{sm:'1200px'}}, }}     >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
        </BootstrapDialogTitle>
        <DialogContent   >
            <Stack width={'100%'} justifyContent={'center'} alignItems={'center'} >
               <img width={'464px'} height={'464px'} src={SucccessImage} alt='Gif'/>
              <Typography color='#292727' fontFamily={'Inter'} fontSize={{xs:'8px', sm:'24px'}} fontStyle={'normal'} fontWeight={500} lineHeight={'normal'}>{message}</Typography>
            </Stack>
           
        </DialogContent>
      
      </BootstrapDialog>
    </div>
  );
}

